import { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  injectStripe,
} from 'react-stripe-elements';
import i18n from '../../config/i18n';

const CheckoutForm = ({
  actions: {
    clearCheckoutToken,
    createWarningAlert,
  },
  checkoutToken,
  stripe,
}) => {
  useEffect(() => {
    stripe.redirectToCheckout({ sessionId: checkoutToken })
      .then(({ error }) => {
        if (error) { createWarningAlert(error); }
      })
      .catch((err) => {
        createWarningAlert(i18n.t('refreshPageWithError', { errMsg: err.message }));
        clearCheckoutToken();
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

CheckoutForm.propTypes = {
  actions: PropTypes.shape({
    createWarningAlert: PropTypes.func.isRequired,
  }).isRequired,
  checkoutToken: PropTypes.string.isRequired,
  stripe: PropTypes.shape({
    redirectToCheckout: PropTypes.func.isRequired,
  }).isRequired,
};

export default injectStripe(CheckoutForm);



// WEBPACK FOOTER //
// ./src/components/subscription/CheckoutForm.js